var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#EDFFED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6951 31.0853C23.18 31.5927 22.353 31.5927 21.838 31.0853L17.1102 26.4285C16.5894 25.9152 16.5894 25.0832 17.1102 24.5715L21.8376 19.915C22.3529 19.4075 23.1801 19.4075 23.6952 19.9152C24.2214 20.4336 24.2212 21.2824 23.6949 21.8007L23.6593 21.8359C22.7843 22.6976 23.3944 24.1867 24.6225 24.1867H30.6869C31.4121 24.1867 32 24.7746 32 25.4998C32 26.225 31.4121 26.8129 30.6869 26.8129H24.6228C23.3944 26.8129 22.784 28.3023 23.6591 29.1644L23.6952 29.2C24.2213 29.7183 24.2213 30.567 23.6951 31.0853Z",
    fill: "#27AD08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowCircle);
export default __webpack_public_path__ + "static/media/leftArrowCircle.f0ae18d57e22e53b841c2fb98fcf52db.svg";
export { ForwardRef as ReactComponent };